import {SignUpViewChanger} from "../util/view-changer/index.js";
import {cancelCompanyJoinRequest} from "../../../apiCall/signup/index.js";
import {sendMoveMobileSignInPage} from "../../../bridge/renewal-signup/index.js";
import {getUserId, isWebView} from "../store.js";


function draw(props) {
    const {userId = ""} = props;
    $("body").append(getCompanyJoinWaitTemplate());
    addEvent(props);
}

function addEvent(props) {
    const {
        userId = ""
    } = props;

    $("#moveSignInBtn").off("click").on("click", () => {
        if(isWebView()) {
            sendMoveMobileSignInPage();
            return;
        }
        SignUpViewChanger.moveSignInPage();
    });

    $("#joinCancelBtn").off("click").on("click", () => {
        clickEventHandlerOfCancelBtn(props);
    });



    if(Mutil.isAct("joinwait.act")) {
        addRefreshPageWarningEvent(userId);
    }
}
function addRefreshPageWarningEvent(userId = "") {
    window.addEventListener("beforeunload", (e) => {
        e.preventDefault();
        Mutil.setCookie("joinUserId", userId, 0, 10 * 1000);
    })
}
function clickEventHandlerOfCancelBtn(props) {
    const {
        userId = ""
    } = props;
    Mutil.confirm({
        text: {contents: `${i18next.t(login.cancelRegisterationDesc)} \n  ${i18next.t(login.cancelRegisterationDesc2)}` ,},
        callback: {
            submitFn: async () => {
                const data = await cancelCompanyJoinRequest(userId);
                if(Mutil.n2v(data.ERR_CD) !== "0000") {
                    Mutil.toast("error", `${i18next.t(common.errorTryAgain)}`);
                    return
                }

                if(isWebView()) {
                    sendMoveMobileSignInPage();
                    return;
                }
                SignUpViewChanger.moveIndexHomePage()
            }
        }
    });
}


function getCompanyJoinWaitTemplate() {
    return `
        <section id="companyJoinWaitSection" class="signup-wide-pop">
          <header></header>
          <article>
            <div class="pop-main">
              <h3>${i18next.t(login.joinRequestComplete)}</h3>
              <div class="req-done-wrap">
                <img src="/flow-renewal/assets/images/sign-req-complete.png" alt="">
                <em>${i18next.t(login.adminPending)}</em>
                <span>${i18next.t(login.adminPendingDesc)}</span>
              </div>
        
              <button id="moveSignInBtn">${i18next.t(common.redirectLoginPage)}</button>
              <button id="joinCancelBtn" class="">${i18next.t(login.cancelRegisteration)}</button>
            </div>
          </article>
        </section>
    `
}

export const CompanyJoinWaitView = {
    draw
}